import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import FormDatePicker from '../../../LEGACY/javascripts/ui/form/form-datepicker';

class AlertDatePicker extends PureComponent {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    moveIn: PropTypes.string,
    moveOut: PropTypes.string
  };

  static defaultProps = {
    moveIn: '',
    moveOut: ''
  };

  handleOnChange = dates => {
    const newDates = {};
    if (dates['move-in']) {
      newDates.moveIn = dates['move-in'];
    }

    if (dates['move-out']) {
      newDates.moveOut = dates['move-out'];
    }

    this.props.onChange(newDates);
  };

  render() {
    return (
      <Fragment>
        <div className="add-edit-form__grid-label">
          {trans('alerts.modal.dates')}
        </div>
        <div>
          <FormDatePicker
            autoCompleteDates
            onChange={this.handleOnChange}
            fromDate={this.props.moveIn}
            toDate={this.props.moveOut}
          />
        </div>
      </Fragment>
    );
  }
}

export default AlertDatePicker;
